export const config = {
  "url_prefix" : "https://gfhoteles.mochi.gdn",
  "self_url" : "https://gfhoteles.menus.mochi.gdn",
  "show_icons" : true,	
  "debug": true
}

